
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { getDefaultExportFromCjs } from '../../../_virtual/_commonjsHelpers.js';
import { l as lib } from '../../../_virtual/index2.js';
import './components/Modal.js';
import { __exports as Modal } from '../../../_virtual/Modal.js';

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = Modal;

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];
}(lib, lib.exports));

var ReactModal = /*@__PURE__*/getDefaultExportFromCjs(lib.exports);

export { ReactModal as default };
//# sourceMappingURL=index.js.map
